<template>
  <div></div>
</template>

<script>
export default {
  name: 'PickupViewer',
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  }
};
</script>
